/**
 * libSQL/SQLite stores timestamps as `YYYY-MM-DD HH:MM:SS` (UTC, no
 * timezone suffix). Both server and web parse and format that shape;
 * keep the helpers in one place so the format assumption isn't
 * spelled out by hand at every call site.
 */

export function formatSqliteDatetime(unixSeconds: number): string {
  return new Date(unixSeconds * 1000).toISOString().replace('T', ' ').slice(0, 19);
}

export function parseSqliteDatetime(value: string): number {
  return Date.parse(value + 'Z');
}
